<template>
    <div class="folder_templates w-100" v-if="isMain == 'home'">
        <div class="folder_row d-flex w-100 flex-wrap" v-if="$store.state.home.tableFileLoader === 1">
        <!-- <div class="folder_row d-flex w-100 flex-wrap" v-if="$store.state.home.tableFileLoader === 3"> -->
            <ShimmerFile />
        </div>
        <div class="folder_row d-flex w-100 flex-wrap" v-else>
            <FileName :myArray="$store.state.home.fileList" :isMain="'home'"/>     
            <div class="col-lg-12">
                <div v-if="$store.state.home.currentPage < $store.state.home.totalPages" class="text-center mt-2 lmbtn">
                    <button
                        @click="loadFileListingData(true)"
                        :disabled="$store.state.home.isHomeImgLoadingMore"
                        class="btn btn-primary btn-block"
                    >
                        {{ $store.state.home.isHomeImgLoadingMore ? 'Loading...' : 'Load More' }}
                    </button>
                </div>       
            </div>       
        </div>
    </div>
    <div class="folder_templates w-100" v-if="isMain == 'starred'">
        <div class="folder_row d-flex w-100 flex-wrap" v-if="$store.state.starred.tableFileLoader === 1">
            <ShimmerFile />
        </div>
        <div class="folder_row d-flex w-100 flex-wrap" v-else>      
            <FileName :myArray="$store.state.starred.fileList" :isMain="'starred'"/>  
            <div class="col-lg-12">     
                <div v-if="$store.state.starred.currentPage < $store.state.starred.totalPages" class="text-center mt-2 lmbtn">
                    <button
                        @click="loadFileListingData(true)"
                        :disabled="$store.state.home.isHomeImgLoadingMore"
                        class="btn btn-primary btn-block"
                    >
                        {{ $store.state.home.isHomeImgLoadingMore ? 'Loading...' : 'Load More' }}
                    </button>
                </div>           
            </div>           
        </div>
    </div>
    <div class="folder_templates w-100" v-if="isMain == 'sharedWithMe'">
        <div class="folder_row d-flex w-100 flex-wrap" v-if="$store.state.sharedWithMe.tableFileLoader === 1">
            <ShimmerFile />
        </div>
        <div class="folder_row d-flex w-100 flex-wrap" v-else>      
            <FileName :myArray="$store.state.sharedWithMe.fileList" :isMain="'sharedWithMe'"/>  
            <div class="col-lg-12">     
                <div v-if="$store.state.sharedWithMe.currentPage < $store.state.sharedWithMe.totalPages" class="text-center mt-2 lmbtn">
                    <button
                        @click="loadFileListingData(true)"
                        :disabled="$store.state.home.isHomeImgLoadingMore"
                        class="btn btn-primary btn-block"
                    >
                        {{ $store.state.home.isHomeImgLoadingMore ? 'Loading...' : 'Load More' }}
                    </button>
                </div>           
            </div>           
        </div>
    </div>
    <div class="folder_templates w-100" v-if="isMain == 'trash'">
        <div class="folder_row d-flex w-100 flex-wrap" v-if="$store.state.trash.tableFileLoader === 1">
            <ShimmerFile />
        </div>
        <div class="folder_row d-flex w-100 flex-wrap" v-else>          
            <FileName :myArray="$store.state.trash.fileList" :isMain="'trash'"/>      
            <div class="col-lg-12">       
                <div v-if="$store.state.trash.currentPage < $store.state.trash.totalPages" class="text-center mt-2 lmbtn">
                    <button
                        @click="loadFileListingData(true)"
                        :disabled="$store.state.home.isHomeImgLoadingMore"
                        class="btn btn-primary btn-block"
                    >
                        {{ $store.state.home.isHomeImgLoadingMore ? 'Loading...' : 'Load More' }}
                    </button>
                </div>            
            </div>            
        </div>
    </div>
</template>

<script>
import ShimmerFile from './ShimmerFile.vue'
import axios from 'axios'
import FileName from './FileName.vue'
import {
        startLoader,
        finishLoader
} from '../../utils/helper.js'
import { post } from '../../utils/api.js'
import { useRoute } from 'vue-router';
export default {
    name: 'ListingFiles',
    components: {
        ShimmerFile,
        FileName,
    },
    data() {
        return {

            currentPage: this.$store.state.home.currentPage,
            totalPages: this.$store.state.home.totalPages,
            pageSize: 2,
            isLoading: false,
            isLoadingMore: false,
        }
    },
    async mounted() {
        if (this.$store.state.isActiveToken != '1') {
            // console.log(this.currentDate);
        } else {
            const route = useRoute();
            if(route.name == 'Home'){
                if(this.$store.state.home.currentPage > 1){
                    await this.reloadHomeFiles();
                }else{
                    await this.loadFileListingData();
                }
            }else if(route.name == 'Starred'){
                if(this.$store.state.starred.currentPage > 1){
                    await this.reloadStarredFiles();
                }else{
                    await this.loadFileListingData();
                }
            }else if(route.name == 'Trash'){
                if(this.$store.state.trash.currentPage > 1){
                    await this.reloadTrashFiles();
                }else{
                    await this.loadFileListingData();
                }
            }else if(route.name == 'ShareWithMe'){
                if(this.$store.state.sharedWithMe.currentPage > 1){
                    await this.reloadSharedWithMeFiles();
                }else{
                    await this.loadFileListingData();
                }
            }else{
                await this.loadFileListingData();
            }

        }
    },
    props: {
        isMain: {
            type: String,
            default: ''
        }
    },
    computed: {
        iAT() {
            return this.$store.state.user.roleId
        },
        reFolderNew() {
            return this.$store.state.home.reLoadPathFolder
        },
        reLoad() {
            return this.$store.state.home.reLoadFilecomponent
        },
        reStarredHomeLoad() {
            return this.$store.state.home.reLoadFileHomeStarredComponent
        },
        reTrashLoad() {
            return this.$store.state.home.reLoadFileTrashComponent
        },
    },
    watch: {
        async iAT(newValue) {
            if (this.$store.state.user.roleId != '') {
                await this.loadFileListingData();
            }
            return newValue
        },
        async reFolderNew(newValue) {
            await this.loadFileListingData();
            return newValue
        },
        async reLoad(newValue) {
            if(this.$store.state.currentPageSlug == 'home'){
                await this.reloadHomeFiles();
            }else if(this.$store.state.currentPageSlug == 'starred'){
                await this.reloadStarredFiles();
            }else if(this.$store.state.currentPageSlug == 'sharedWithMe'){
                await this.reloadSharedWithMeFiles();
            }else if(this.$store.state.currentPageSlug == 'trash'){
                await this.reloadTrashFiles();
            }else{
                await this.reloadHomeFiles();
            }
            return newValue
        },
        async reStarredHomeLoad(newValue) {
            if(this.$store.state.currentPageSlug == 'home'){
                await this.reloadHomeFiles();
            }else if(this.$store.state.currentPageSlug == 'starred'){
                await this.reloadStarredFiles();
            }else if(this.$store.state.currentPageSlug == 'sharedWithMe'){
                await this.reloadSharedWithMeFiles();
            }else{
                await this.reloadHomeFiles();
            }
            return newValue
        },
        async reTrashLoad(newValue) {
            await this.reloadTrashFiles();
            return newValue
        },
    },
    methods: {
        startLoader,
        finishLoader,
        async loadHomeFileListingData() {
            try {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.state.user.accessToken;
                let _post = {}
                
                _post = {
                    folderName: this.folderName,
                    pageLength: this.$store.state.pageSize,
                    page: this.$store.state.home.currentPage,
                };

                let resp = ''
                resp = await post('files/list-files', _post)
                this.$store.state.home.isHomeImgLoadingMore = false;
                if (resp.status == 200 && resp.data.status == 'success') {
                    if(this.$store.state.home.currentPage > 1){
                        const newFiles = resp.data.data.files;
                        this.$store.state.home.currentPage = resp.data.data.page
                        // Get existing keys
                        const existingKeys = new Set(this.$store.state.home.fileList.map(f => f.key));
    
                        // Filter new files that aren't already in the list
                        const uniqueNewFiles = newFiles.filter(f => !existingKeys.has(f.key));
    
                        // Append unique files
                        this.$store.state.home.fileList.push(...uniqueNewFiles);

                    }else{
                        this.$store.state.home.fileList = resp.data.data.files;
                    }
                    
                    // Loader state
                    this.$store.state.home.tableFileLoader = this.$store.state.home.fileList.length > 0 ? 3 : 2;

                    // Total pages from backend
                    this.$store.state.home.totalPages = resp.data.data.totalPages || 1;
                    this.$store.state.home.fileCount = resp.data.data.fileCount || 1;
                    
                    this.finishLoader();
                }
                
            } catch (error) {
                this.finishLoader();
                console.error('Error:', error.response?.data || error.message)
            }
        },
        async loadStarredFileListingData() {
            this.startLoader();
            let resp = ''
            resp = await axios.get(process.env.VUE_APP_API_URL + 'starred/files', {
                params: {
                    pageLength: this.$store.state.pageSize,
                    page: this.$store.state.starred.currentPage,
                }
            })
            this.$store.state.home.isHomeImgLoadingMore = true;
            if (resp.status == 200 && resp.data.status == 'success') {

                if(this.$store.state.starred.currentPage > 1){
                    const newFiles = resp.data.data.files;
                    // Get existing keys
                    const existingKeys = new Set(this.$store.state.starred.fileList.map(f => f._id));
    
                    // Filter new files that aren't already in the list
                    const uniqueNewFiles = newFiles.filter(f => !existingKeys.has(f._id));
    
                    // Append unique files
                    this.$store.state.starred.fileList.push(...uniqueNewFiles);
                }else{
                    this.$store.state.starred.fileList = resp.data.data.files;
                }
                this.$store.state.home.isHomeImgLoadingMore = false;
                // Loader state
                this.$store.state.starred.tableFileLoader = this.$store.state.starred.fileList.length > 0 ? 3 : 2;

                let totalCount = resp.data.data.totalCount || 1;
                totalCount = totalCount / this.$store.state.pageSize;
                this.$store.state.starred.totalPages = totalCount;
                this.finishLoader();
            }
        },
        async loadSharedWithMeFileListingData() {
            this.startLoader();
            let resp = ''
            resp = await axios.get(process.env.VUE_APP_API_URL + 'files/share-with-me-files', {
                params: {
                    pageLength: this.$store.state.pageSize,
                    page: this.$store.state.sharedWithMe.currentPage,
                }
            })
            this.$store.state.home.isHomeImgLoadingMore = true;
            if (resp.status == 200 && resp.data.status == 'success') {
                if(this.$store.state.sharedWithMe.currentPage > 1){
                    const newFiles = resp.data.data.files;
                    const existingKeys = new Set(this.$store.state.sharedWithMe.fileList.map(f => f.key));
    
                    // Filter new files that aren't already in the list
                    const uniqueNewFiles = newFiles.filter(f => !existingKeys.has(f.key));
    
                    // Append unique files
                    this.$store.state.sharedWithMe.fileList.push(...uniqueNewFiles);

                }else{
                    this.$store.state.sharedWithMe.fileList = resp.data.data.files;
                }
                this.$store.state.home.isHomeImgLoadingMore = false;
                // Loader state
                this.$store.state.sharedWithMe.tableFileLoader = this.$store.state.sharedWithMe.fileList.length > 0 ? 3 : 2;

                let totalCount = resp.data.data.totalCount || 1;
                totalCount = totalCount / this.$store.state.pageSize;
                this.$store.state.sharedWithMe.totalPages = totalCount;
                this.finishLoader();
            }
        },
        async loadTrashFileListingData() {
            this.startLoader();
            let resp = ''
            resp = await axios.get(process.env.VUE_APP_API_URL + 'files/trash-files', {
                params: {
                    pageLength: this.$store.state.pageSize,
                    page: this.$store.state.trash.currentPage,
                }
            })
            this.$store.state.home.isHomeImgLoadingMore = false;
            if (resp.status == 200 && resp.data.status == 'success') {
                if(this.$store.state.trash.currentPage > 1){
                    const newFiles = resp.data.data.files;
                    // this.$store.state.trash.currentPage += 1
                    // Get existing keys
                    const existingKeys = new Set(this.$store.state.trash.fileList.map(f => f.key));
    
                    // Filter new files that aren't already in the list
                    const uniqueNewFiles = newFiles.filter(f => !existingKeys.has(f.key));
    
                    // Append unique files
                    this.$store.state.trash.fileList.push(...uniqueNewFiles);

                }else{
                    this.$store.state.trash.fileList = resp.data.data.files;
                }

                // Loader state
                this.$store.state.trash.tableFileLoader = this.$store.state.trash.fileList.length > 0 ? 3 : 2;

                let totalCount = resp.data.data.totalCount || 1;
                totalCount = totalCount / this.$store.state.pageSize;
                this.$store.state.trash.totalPages = totalCount;

                this.finishLoader();
            }
        },
        async reloadHomeFiles() {
            const psadaageSize = this.$store.state.pageSize * this.$store.state.home.currentPage
            
            this.startLoader();
            
            let _post = {}
            _post = {
                folderName: this.folderName,
                pageLength: psadaageSize,
                page: 1,
                test: this.$store.state.home.currentPage,
                pageSize: this.$store.state.pageSize,
            }

            const resp = await post('files/list-files', _post)
            this.$store.state.home.isHomeImgLoadingMore = false;
            if (resp.status == 200 && resp.data.status == 'success') {
                const newFiles = resp.data.data.files;
                const fileCount = resp.data.data.fileCount;
                if(this.$store.state.home.removeFolderStarrd == 2){
                    this.$store.state.home.fileList = [] 
                }

                if(fileCount > psadaageSize){
                    this.$store.state.pageSize = fileCount;
                }
                this.$store.state.home.fileList =  newFiles
                this.$store.state.home.tableFileLoader = this.$store.state.home.fileList.length > 0 ? 3 : 2;
                this.$store.state.home.fileCount = resp.data.data.fileCount;
                this.finishLoader();
            }  
        },
        async reloadStarredFiles() {
            const psadaageSize = this.$store.state.pageSize * this.$store.state.starred.currentPage
            
            this.startLoader();
            let resp = ''
            resp = await axios.get(process.env.VUE_APP_API_URL + 'starred/files', {
                params: {
                    pageLength: psadaageSize,
                    page: 1,
                }
            })
            this.$store.state.home.isHomeImgLoadingMore = false;
            
            if (resp.status == 200 && resp.data.status == 'success') {
                const newFiles = resp.data.data.files;
                if(this.$store.state.starred.removeFolderStarrd == 2){
                    this.$store.state.starred.fileList = [] 
                }
                this.$store.state.starred.fileList =  newFiles

                 let totalCount = resp.data.data.totalCount || 1;
                totalCount = totalCount / this.$store.state.pageSize;
                this.$store.state.starred.totalPages = totalCount;

                this.finishLoader();
            }  
        },
        async reloadSharedWithMeFiles() {
            const psadaageSize = this.$store.state.pageSize * this.$store.state.sharedWithMe.currentPage
            
            this.startLoader();
            let resp = ''
            resp = await axios.get(process.env.VUE_APP_API_URL + 'files/share-with-me-files', {
                params: {
                    pageLength: psadaageSize,
                    page: 1,
                }
            })
            this.$store.state.home.isHomeImgLoadingMore = false;
            
            if (resp.status == 200 && resp.data.status == 'success') {
                const newFiles = resp.data.data.files;
                if(this.$store.state.sharedWithMe.removeFolderStarrd == 2){
                    this.$store.state.sharedWithMe.fileList = [] 
                }
                this.$store.state.sharedWithMe.fileList =  newFiles

                this.finishLoader();
            }  
        },
        async reloadTrashFiles() {
            const psadaageSize = this.$store.state.pageSize * this.$store.state.trash.currentPage
            
            this.startLoader();
            let resp = ''
            resp = await axios.get(process.env.VUE_APP_API_URL + 'files/trash-files', {
                params: {
                    pageLength: psadaageSize,
                    page: 1,
                }
            })
            this.$store.state.home.isHomeImgLoadingMore = false;
            
            if (resp.status == 200 && resp.data.status == 'success') {
                const newFiles = resp.data.data.files;
                if(this.$store.state.trash.removeFolderStarrd == 2){
                    this.$store.state.trash.fileList = [] 
                }
                this.$store.state.trash.fileList =  newFiles

                this.finishLoader();
            }  
        },
        async loadFileListingData(loadMore = false) {
            try {
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.state.user.accessToken;
                
                if(this.isMain == 'home') {
                    if (!loadMore) {
                        this.startLoader();
                        this.fileList = [];
                        // this.currentPage = 1;
                    } else {
                        this.$store.state.home.currentPage += 1;
                        this.$store.state.home.isHomeImgLoadingMore = true;
                    }
                    this.loadHomeFileListingData();
                    
                } else if (this.isMain == 'starred') {
                    if (!loadMore) {
                        // this.startLoader();
                        this.fileList = [];
                        // this.currentPage = 1;
                    } else {
                        this.$store.state.starred.currentPage += 1;
                        this.$store.state.home.isHomeImgLoadingMore = true;
                    }
                    this.loadStarredFileListingData();
                } else if (this.isMain == 'sharedWithMe') {
                    if (!loadMore) {
                        // this.startLoader();
                        this.fileList = [];
                        // this.currentPage = 1;
                    } else {
                        this.$store.state.sharedWithMe.currentPage += 1;
                        this.$store.state.home.isHomeImgLoadingMore = true;
                    }
                    this.loadSharedWithMeFileListingData();
                    
                } else if (this.isMain == 'trash') {
                    if (!loadMore) {
                        // this.startLoader();
                        this.fileList = [];
                        // this.currentPage = 1;
                    } else {
                        this.$store.state.trash.currentPage += 1;
                        this.$store.state.home.isHomeImgLoadingMore = true;
                    }
                    this.loadTrashFileListingData();
                  
                } else {
                    if (!loadMore) {
                        this.startLoader();
                        this.fileList = [];
                        // this.currentPage = 1;
                    } else {
                        this.$store.state.home.currentPage += 1;
                        this.$store.state.home.isHomeImgLoadingMore = true;
                    }
                    this.loadHomeFileListingData();
                }                
            } catch (error) {
                this.finishLoader();
                console.error('Error:', error.response?.data || error.message)
            }
        },
    },
}
</script>
